import { formatDateCommon, formatMergeDateAndTime, STR_DATE_TIME } from '@/utils/format';
import { showMessage } from '@/utils/messages';
import { TABS, SOCIAL_MEDIA_SHARE, LIST_FONT_PAGE } from './constants';
import { LIST_TEMPLATE_DEFAULT } from './styles';
import {
    LIST_STYLE_TIME,
    LIST_STYLE_PRIZE,
    LIST_STYLE_TARGET_PRODUCT,
    LIST_STYLE_APPLICATION_METHODS,
    LIST_STYLE_CONTACT,
    LIST_STYLE_APPLICATION_RULE,
    LIST_STYLE_FREE_BLOCK,
    LIST_STYLE_BUTTON_BLOCK
} from './styles';
import { landingPageService } from '@/api/services/landing-page.service';
import moment from 'moment';
import i18n from '@/i18n';
import Swal from 'sweetalert2';

let imgPrizeDefault = '/images/landingpage/prize_default.jpg';

function handleDataBeforeSaveLP(dataForm) {
    const isUpload = dataForm.lp_type === 2 || dataForm.type === 2;
    return {
        lp_type: isUpload ? 2 : 1,
        type: isUpload ? 2 : 1,
        resources_zip_start: Array.isArray(dataForm.resources_zip_start) ? dataForm.resources_zip_start : [],
        resources_zip_going: Array.isArray(dataForm.resources_zip_going) ? dataForm.resources_zip_going : [],
        resources_zip_end: Array.isArray(dataForm.resources_zip_end) ? dataForm.resources_zip_end : [],
        resources_zip: Array.isArray(dataForm.resources_zip) ? dataForm.resources_zip : [],
        campaign: dataForm?.campaign?.id
            ? {
                  id: dataForm?.campaign?.id
              }
            : null,
        instruction_pic: dataForm.sale_staff?.id
            ? {
                  id: dataForm?.sale_staff?.id
              }
            : null,
        business_pic: dataForm.person_in_charge?.id
            ? {
                  id: dataForm?.person_in_charge?.id
              }
            : null,
        name: dataForm.name,
        custom_domain_id: dataForm.custom_domain_id,
        url_public: dataForm.url_public,
        lp_start_date: formatMergeDateAndTime(dataForm.lp_start_date, dataForm.lp_start_time),
        lp_end_date: formatMergeDateAndTime(dataForm.lp_end_date, dataForm.lp_end_time),
        campaign_start_date: formatMergeDateAndTime(dataForm.campaign_start_date, dataForm.campaign_start_time),
        campaign_end_date: formatMergeDateAndTime(dataForm.campaign_end_date, dataForm.campaign_end_time),
        publication_start_date: formatMergeDateAndTime(dataForm.publication_start_date, dataForm.publication_start_time),
        publication_end_date: formatMergeDateAndTime(dataForm.publication_end_date, dataForm.publication_end_time),
        status: dataForm.status,
        automatic_status_update: dataForm.automatic_status_update,
        keywords: dataForm.keywords,
        description: dataForm.description,
        analytics: dataForm.analytics,
        head_source: dataForm.head_source,
        body_directly_below: dataForm.body_directly_below,
        og_image: dataForm?.og_image?.id
            ? {
                  id: dataForm?.og_image?.id
              }
            : null,

        landing_page_user: dataForm.landing_page_user?.username ? dataForm.landing_page_user : null,
        ...(dataForm.id !== null &&
            dataForm.id !== undefined && {
                id: dataForm.id,

                //----- start setting blocks --------------
                block_arrangement: dataForm.blocks_settings.map((itemBlock) => {
                    const hasKey = itemBlock.key ? (itemBlock.key === 'prize_settings' ? 'block_prize' : itemBlock.key) : '';
                    return {
                        type: itemBlock.block_default ? 'predefined' : 'custom',
                        position: itemBlock.order_index,
                        status: itemBlock.is_visibled ? 1 : 0,
                        key: hasKey,
                        key_parent: itemBlock?.key_parent ?? ''
                    };
                }),
                //----- end setting blocks --------------

                //----- start header_information --------------
                header_information: {
                    html_content_first_view: dataForm.header_information.html_content_first_view ?? '',
                    html_content_finished_view: dataForm.header_information.html_content_finished_view ?? ''
                },
                //----- end header_information --------------

                //----- start setting firstview --------------
                first_view: {
                    image: {
                        ...(dataForm.first_view?.image?.id !== null &&
                            dataForm.first_view?.image?.id !== undefined && {
                                id: dataForm.first_view.image.id
                            })
                    },
                    finished_image: {
                        ...(dataForm.first_view?.finished_image?.id !== null &&
                            dataForm.first_view?.finished_image?.id !== undefined && {
                                id: dataForm.first_view.finished_image.id
                            })
                    },
                    html_content: dataForm.first_view?.html_content
                },
                application_period: {
                    title: dataForm.application_period.title,
                    style_id: dataForm.application_period.style?.id ?? null,
                    start_date: dataForm.application_period.start_date,
                    end_date: dataForm.application_period.end_date,
                    html_content: dataForm.application_period.html_content
                },
                //----- end setting firstview --------------

                //----- start setting prize settings  --------------
                block_prize: {
                    title_block: dataForm.prize_settings.title ?? '',
                    title_image: dataForm.prize_settings.title_image?.id
                        ? {
                              id: dataForm.prize_settings.title_image?.id
                          }
                        : null,
                    size_title: dataForm.prize_settings.size_title || '24',
                    color_title: dataForm.prize_settings.color_title ?? '',
                    background_title: dataForm.prize_settings.background_title ?? '',
                    background_image: dataForm.prize_settings.background.image?.id
                        ? {
                              id: dataForm.prize_settings.background.image?.id
                          }
                        : null,
                    background_color: dataForm.prize_settings.background.color ?? '',
                    is_repeat: dataForm.prize_settings.is_repeat || false,
                    style: dataForm.prize_settings.style?.id ?? null,
                    prizes: dataForm.prize_settings.prizes.map((preItem, idx) => {
                        return {
                            ...(preItem.id !== null &&
                                preItem.id !== undefined && {
                                    id: preItem.id
                                }),
                            order_index: idx,
                            title: preItem.title,
                            size_prize: preItem.size_prize || '24',
                            color_prize: preItem.color_prize,
                            background_prize: preItem.background_prize,
                            background_item: preItem.background_item,
                            image: {
                                id: preItem?.image?.id ?? null
                            },
                            detail: preItem.detail,
                            number_of_winner: preItem?.number_of_winner?.toString() ?? '',
                            status: preItem.status,
                            campaign_event_prize_id: preItem?.campaign_event_prize_id ?? ''
                        };
                    }),
                    html_content: dataForm.prize_settings.html_content ?? ''
                },
                //----- end setting prize settings  --------------

                //----- start setting target product settings  --------------
                block_target_product: {
                    ...dataForm?.block_target_product,
                    title_image: dataForm.block_target_product.title_image?.id
                        ? {
                              id: dataForm.block_target_product.title_image?.id
                          }
                        : null,
                    size_title: dataForm.block_target_product.size_title || '24',
                    style: dataForm.block_target_product.style?.id ?? null,
                    background_image: dataForm?.block_target_product?.background_image?.id
                        ? {
                              id: dataForm?.block_target_product?.background_image?.id
                          }
                        : null,
                    target_products: dataForm.block_target_product.target_products.map((itemTargetPro, idx) => {
                        return {
                            ...(itemTargetPro?.id !== null &&
                                itemTargetPro.id && {
                                    id: itemTargetPro.id
                                }),
                            background_item: itemTargetPro.background_item,
                            background_product: itemTargetPro.background_product,
                            color_product: itemTargetPro.color_product,
                            detail: itemTargetPro.detail,
                            image: itemTargetPro.image,
                            order_index: idx,
                            size_product: itemTargetPro.size_product || '24',
                            status: itemTargetPro.status,
                            title: itemTargetPro.title
                        };
                    })
                },
                //----- end setting target product settings  --------------

                //----- start setting application method settings  --------------
                block_application_method: {
                    ...dataForm.block_application_method,
                    title_image: dataForm.block_application_method.title_image?.id
                        ? {
                              id: dataForm.block_application_method.title_image?.id
                          }
                        : null,
                    size_title: dataForm.block_application_method.size_title || '24',
                    style: dataForm.block_application_method.style?.id ?? null,
                    background_image: dataForm?.block_application_method?.background_image?.id
                        ? {
                              id: dataForm?.block_application_method?.background_image?.id
                          }
                        : null,
                    application_methods: dataForm.block_application_method.application_methods.map((itemMethod, idx) => {
                        return {
                            ...(itemMethod.id !== null &&
                                itemMethod.id !== undefined && {
                                    id: itemMethod.id
                                }),
                            order_index: idx,
                            title: itemMethod.title,
                            size_method: itemMethod.size_method || '24',
                            color_method: itemMethod.color_method,
                            background_method: itemMethod.background_method,
                            background_item: itemMethod.background_item,
                            image: itemMethod.image,
                            detail: itemMethod.detail,
                            status: itemMethod.status
                        };
                    })
                },
                //----- end setting application method settings  --------------

                //----- start setting receipt photography settings  --------------
                block_receipt_photography_tutorial: {
                    html_content: dataForm?.block_receipt_photography_tutorial?.html_content ?? ''
                },
                //----- end setting receipt photography settings  --------------

                //----- start setting application rule settings  --------------
                block_application_rule: {
                    ...dataForm.block_application_rule,
                    size_title: dataForm.block_application_rule.size_title || '24',
                    background_image: dataForm?.block_application_rule?.background_image?.id
                        ? {
                              id: dataForm?.block_application_rule?.background_image?.id
                          }
                        : null,
                    style: dataForm.block_application_rule.style?.id ?? null
                },
                //----- end setting application rule settings  --------------

                //----- start setting share settings  --------------
                block_share: {
                    ...dataForm.block_share,
                    background_image: dataForm?.block_share?.background_image?.id
                        ? {
                              id: dataForm?.block_share?.background_image?.id
                          }
                        : null,
                    style: dataForm.block_share.style?.id ?? null
                },
                //----- end setting share settings  --------------

                //----- start setting contact settings  --------------
                block_contact: {
                    ...dataForm.block_contact,
                    size_title: dataForm.block_contact.size_title || '24',
                    background_image: dataForm?.block_contact?.background_image?.id
                        ? {
                              id: dataForm?.block_contact?.background_image?.id
                          }
                        : null,
                    style: dataForm.block_contact.style?.id ?? null
                },
                //----- end setting contact settings  --------------

                //----- start setting free blocks settings  --------------
                free_blocks:
                    dataForm?.free_blocks?.map((itemFree) => {
                        return {
                            ...(itemFree.id !== null &&
                                itemFree.id !== undefined && {
                                    id: itemFree.id
                                }),
                            title: itemFree.title,
                            size_title: itemFree?.size_title ?? '24',
                            color_title: itemFree?.color_title ?? '',
                            background_title: itemFree?.background_title ?? '',
                            style: itemFree?.style?.id ?? null,
                            html_content: itemFree.html_content,
                            key_parent: itemFree?.key_parent ?? ''
                        };
                    }) ?? [],
                //----- start setting free blocks settings  --------------

                //----- start setting button blocks settings  --------------
                button_blocks:
                    dataForm?.button_blocks?.map((itemButton) => {
                        return {
                            ...(itemButton.id !== null &&
                                itemButton.id !== undefined && {
                                    id: itemButton.id
                                }),
                            title_block: itemButton.title_block,
                            title_button: itemButton.title_button,
                            url: itemButton.url,
                            style: itemButton?.style?.id ?? null,
                            color: itemButton?.color ?? '',
                            background_color: itemButton?.background_color ?? '',
                            key_parent: itemButton?.key_parent ?? '',
                            font_button: itemButton.font_button?.id ?? null,
                            html_content: itemButton?.html_content ?? ''
                        };
                    }) ?? [],
                //----- start setting button blocks settings  --------------
                //----- start setting style setting settings  --------------
                pc_background_image_id: dataForm?.style_setting?.pc?.background_image?.id ?? null,
                sp_background_image_id: dataForm?.style_setting?.sp?.background_image?.id ?? null,
                style_setting: {
                    ...dataForm?.style_setting,
                    font: dataForm?.style_setting?.font?.id ?? null,
                    border_radius_type: dataForm?.style_setting?.border_radius_type ?? '',
                    pc: {
                        background_color: dataForm?.style_setting?.pc?.background_color ?? '',
                        is_repeat: dataForm?.style_setting?.pc?.is_repeat
                    },
                    sp: {
                        background_color: dataForm?.style_setting?.sp?.background_color ?? '',
                        is_repeat: dataForm?.style_setting?.sp?.is_repeat
                    }
                }
                //----- start setting style setting settings  --------------
            })
    };
}

function handleDataResponse(dataForm, data, dataCampain) {
    let { event_prizes, campaign_start_date, campaign_end_date } = dataCampain;

    dataForm.lp_type = data?.lp_type ?? data?.type ?? 1;
    dataForm.resources_zip_start = data?.resources_zip_start ?? [];
    dataForm.resources_zip_going = data?.resources_zip_going ?? [];
    dataForm.resources_zip_end = data?.resources_zip_end ?? [];
    dataForm.resources_zip = data?.resources_zip ?? dataForm.resources_zip_start;
    dataForm.id = data?.id ?? null;
    dataForm.zac_id = data?.campaign?.zac_id;
    dataForm.sfid = data?.campaign?.sfid;
    dataForm.number_cp = data?.campaign?.code;
    dataForm.campaign_entity_id = data?.campaign?.campaign_entity_id;
    dataForm.sale_staff = data?.instruction_pic ?? data?.campaign?.sale_staff ?? '';
    dataForm.person_in_charge = data?.business_pic ?? data?.campaign?.person_in_charge;
    dataForm.campaign = data?.campaign ?? null;
    dataForm.campaign_not_change = data?.campaign ?? null;
    dataForm.code = data?.code ?? null;
    dataForm.name = data?.name ?? '';
    dataForm.custom_domain_id = data?.custom_domain_id ?? data?.custom_domain?.id ?? null;
    dataForm.custom_domain = data?.custom_domain ?? null;
    dataForm.url_public = data?.url_public;
    dataForm.lp_start_time = formatDateCommon(data?.lp_start_date, 'dateTime');
    dataForm.lp_end_time = formatDateCommon(data?.lp_end_date, 'dateTime');
    dataForm.campaign_start_time = formatDateCommon(data?.campaign_start_date, 'dateTime');
    dataForm.campaign_end_time = formatDateCommon(data?.campaign_end_date, 'dateTime');
    dataForm.publication_start_time = formatDateCommon(data?.publication_start_date, 'dateTime');
    dataForm.publication_end_time = formatDateCommon(data?.publication_end_date, 'dateTime');
    dataForm.lp_start_date = formatDateCommon(data?.lp_start_date, 'date');
    dataForm.lp_end_date = formatDateCommon(data?.lp_end_date, 'date');
    dataForm.campaign_start_date = formatDateCommon(data?.campaign_start_date, 'date');
    dataForm.campaign_end_date = formatDateCommon(data?.campaign_end_date, 'date');
    dataForm.publication_start_date = formatDateCommon(data?.publication_start_date, 'date');
    dataForm.publication_end_date = formatDateCommon(data?.publication_end_date, 'date');
    dataForm.status = data?.status;
    dataForm.automatic_status_update = data?.automatic_status_update === 1 ? true : false;
    dataForm.keywords = data?.keywords;
    dataForm.description = data?.description;
    dataForm.analytics = data?.analytics;
    dataForm.head_source = data?.head_source;
    dataForm.body_directly_below = data?.body_directly_below;
    dataForm.og_image = data?.og_image ?? null;
    dataForm.last_publish_updated = data?.last_publish_updated ?? '';
    dataForm.landing_page_user = {
        ...dataForm.landing_page_user,
        ...data?.landing_page_user
    };
    dataForm.block_arrangement = data?.block_arrangement;
    dataForm.is_first_publish = data?.is_first_publish;
    dataForm.published_domain = data?.published_domain ?? null;
    dataForm.campaign_forms = data?.campaign_forms ?? [];
    dataForm.campaign_lps = data?.campaign_lps ?? [];

    //----- start setting blocks --------------
    if (data?.block_arrangement) {
        dataForm.blocks_settings = onHandleMapBlockRes(dataForm.blocks_settings, data?.block_arrangement, dataForm, data);
    }
    //----- end setting blocks --------------

    //----- start header_information --------------
    dataForm.header_information = {
        html_content_first_view: data?.header_information?.html_content_first_view ?? '',
        html_content_finished_view: data?.header_information?.html_content_finished_view ?? ''
    };
    //----- end header_information --------------

    //----- start setting firstview --------------
    dataForm.first_view = {
        campaign: data?.campaign,
        image: data?.first_view?.image ?? null,
        finished_image: data?.first_view?.finished_image ?? null,
        html_content: data?.first_view?.html_content ?? ''
    };
    dataForm.application_period = {
        title: data?.application_period?.title ?? '応募期間',
        style: data?.application_period?.style_id
            ? mapImageDefault(LIST_STYLE_TIME).find((oStyle) => oStyle.id === data?.application_period?.style_id)
            : null,
        start_date: data?.application_period?.start_date ?? (campaign_start_date ? moment(campaign_start_date).format('YYYY年MM月DD日 HH:mm') : null),
        end_date: data?.application_period?.end_date ?? (campaign_end_date ? moment(campaign_end_date).format('YYYY年MM月DD日 HH:mm') : null),
        html_content: data?.application_period?.html_content ?? ''
    };
    //----- end setting firstview --------------

    //----- start setting prize settings  --------------
    dataForm.prize_settings = {
        ...(data?.block_prize?.id !== null &&
            data?.block_prize?.id !== undefined && {
                id: data?.block_prize?.id
            }),
        title: data.block_prize?.title_block ?? '賞品',
        title_image: data.block_prize?.title_image ?? '',
        size_title: data.block_prize?.size_title ?? '24',
        color_title: data.block_prize?.color_title ?? '',
        background_title: data.block_prize?.background_title ?? '',
        background: {
            image: data.block_prize?.background_image ?? null,
            color: data.block_prize?.background_color ?? ''
        },
        is_repeat: data.block_prize?.is_repeat ? (data.block_prize?.is_repeat === 0 ? false : true) : false,
        style: data.block_prize?.style ? mapImageDefault(LIST_STYLE_PRIZE).find((oStyle) => oStyle.id === data.block_prize?.style) : null,
        html_content: data.block_prize?.html_content ?? '',
        prizes: handleResponePrize(data.block_prize?.prizes, event_prizes) ?? []
    };
    //----- end setting prize settings  --------------

    //----- start setting target product settings  --------------
    dataForm.block_target_product = {
        ...(data?.block_target_product?.id !== null &&
            data?.block_target_product?.id !== undefined && {
                id: data?.block_target_product?.id
            }),
        title_block: data?.block_target_product?.title_block ?? '対象商品',
        title_image: data.block_target_product?.title_image ?? '',
        size_title: data?.block_target_product?.size_title ?? '24',
        color_title: data?.block_target_product?.color_title ?? '',
        background_title: data?.block_target_product?.background_title ?? '',
        background_image: data?.block_target_product?.background_image ?? null,
        background_color: data?.block_target_product?.background_color ?? '#000',
        is_repeat: data?.block_target_product?.is_repeat ? (data?.block_target_product?.is_repeat === 0 ? false : true) : false,
        style: data?.block_target_product?.style
            ? mapImageDefault(LIST_STYLE_TARGET_PRODUCT).find((oStyle) => oStyle.id === data?.block_target_product?.style)
            : null,
        target_products:
            data?.block_target_product?.target_products?.map((op) => {
                op.make_id = op.id;
                op.status = op.status === 0 ? false : true;
                op.detail = op.detail ?? '';
                return op;
            }) ?? [],
        html_content: data?.block_target_product?.html_content ?? ''
    };
    //----- end setting target product settings  --------------

    //----- start setting application method settings  --------------
    dataForm.block_application_method = {
        ...(data?.block_application_method?.id !== null &&
            data?.block_application_method?.id !== undefined && {
                id: data?.block_application_method?.id
            }),
        title_block: data?.block_application_method?.title_block ?? '応募方法',
        title_image: data.block_application_method?.title_image ?? '',
        size_title: data.block_application_method?.size_title ?? '24',
        color_title: data.block_application_method?.color_title ?? '',
        background_title: data.block_application_method?.background_title ?? '',
        background_image: data?.block_application_method?.background_image ?? null,
        background_color: data?.block_application_method?.background_color ?? '',
        is_repeat: data?.block_application_method?.is_repeat ? (data?.block_application_method?.is_repeat === 0 ? false : true) : false,
        style: data.block_application_method?.style
            ? mapImageDefault(LIST_STYLE_APPLICATION_METHODS).find((oStyle) => oStyle.id === data.block_application_method?.style)
            : null,
        application_methods:
            data?.block_application_method?.application_methods?.map((itemAppM) => {
                itemAppM.status = itemAppM.status === 0 ? false : true;
                itemAppM.detail = itemAppM.detail ?? '';
                return itemAppM;
            }) ?? [],
        html_content: data?.block_application_method?.html_content ?? ''
    };
    //----- end setting application method settings  --------------

    //----- start setting receipt photography settings  --------------
    dataForm.block_receipt_photography_tutorial = {
        html_content: data.block_receipt_photography_tutorial?.html_content ?? ''
    };
    //----- end setting receipt photography settings  --------------

    //----- start setting application rule settings  --------------
    dataForm.block_application_rule = {
        ...(data?.block_application_rule?.id !== null &&
            data?.block_application_rule?.id !== undefined && {
                id: data?.block_application_rule?.id
            }),
        title_block: data?.block_application_rule?.title_block ?? '応募規約',
        size_title: data.block_application_rule?.size_title ?? '24',
        color_title: data.block_application_rule?.color_title ?? '',
        background_title: data.block_application_rule?.background_title ?? '',
        background_image: data?.block_application_rule?.background_image ?? null,
        background_color: data?.block_application_rule?.background_color ?? '',
        is_repeat: data?.block_application_rule?.is_repeat ? (data?.block_application_rule?.is_repeat === 0 ? false : true) : false,
        style: data.block_application_rule?.style
            ? mapImageDefault(LIST_STYLE_APPLICATION_RULE).find((oStyle) => oStyle.id === data.block_application_rule?.style)
            : null,
        html_content: data?.block_application_rule?.html_content ?? ''
    };
    //----- end setting application rule settings  --------------

    //----- start setting share settings  --------------
    dataForm.block_share = {
        ...(data?.block_share?.id !== null &&
            data?.block_share?.id !== undefined && {
                id: data?.block_share?.id
            }),
        title_block: data?.block_share?.title_block ?? 'シェアブロック',
        background_image: data?.block_share?.background_image ?? null,
        background_color: data?.block_share?.background_color ?? '',
        is_repeat: data?.block_share?.is_repeat ? (data?.block_share?.is_repeat === 0 ? false : true) : false,
        url: data?.block_share?.url ?? '',
        share_text: data?.block_share?.share_text ?? '',
        html_content: data?.block_share?.html_content ?? '',
        hashtag: data?.block_share?.hashtag ?? [],
        platform: {
            facebook: {
                active: data?.block_share?.platform?.facebook?.active ? (data?.block_share?.platform?.facebook?.active === 0 ? false : true) : false,
                url: data?.block_share?.platform?.facebook?.url ?? ''
            },
            line: {
                active: data?.block_share?.platform?.line?.active ? (data?.block_share?.platform?.line?.active === 0 ? false : true) : false,
                url: data?.block_share?.platform?.line?.url ?? ''
            },
            x: {
                active: data?.block_share?.platform?.x?.active ? (data?.block_share?.platform?.x?.active === 0 ? false : true) : false,
                url: data?.block_share?.platform?.x?.url ?? ''
            },
            instagram: {
                active: data?.block_share?.platform?.instagram?.active
                    ? data?.block_share?.platform?.instagram?.active === 0
                        ? false
                        : true
                    : false,
                url: data?.block_share?.platform?.instagram?.url ?? ''
            },
            pinterest: {
                active: data?.block_share?.platform?.pinterest?.active
                    ? data?.block_share?.platform?.pinterest?.active === 0
                        ? false
                        : true
                    : false,
                url: data?.block_share?.platform?.pinterest?.url ?? ''
            }
        }
    };
    //----- end setting share settings  --------------

    //----- start setting contact settings  --------------
    dataForm.block_contact = {
        ...(data?.block_contact?.id !== null &&
            data?.block_contact?.id !== undefined && {
                id: data?.block_contact?.id
            }),
        title_block: data?.block_contact?.title_block ?? 'お問い合わせ',
        size_title: data.block_contact?.size_title ?? '24',
        color_title: data.block_contact?.color_title ?? '',
        background_title: data.block_contact?.background_title ?? '',
        background_image: data?.block_contact?.background_image ?? null,
        background_color: data?.block_contact?.background_color ?? '',
        is_repeat: data?.block_contact?.is_repeat ? (data?.block_contact?.is_repeat === 0 ? false : true) : false,
        style: data.block_contact?.style ? mapImageDefault(LIST_STYLE_CONTACT).find((oStyle) => oStyle.id === data.block_contact?.style) : null,
        contact_secretariat_name: data?.block_contact?.contact_secretariat_name ?? dataCampain?.inquiry_office ?? '',
        tel: data?.block_contact?.tel ?? dataCampain?.master_order_scope_phone_number ?? '',
        mail: data?.block_contact?.mail ?? dataCampain?.contact_information_email ?? '',
        html_content: data?.block_contact?.html_content ?? ''
    };
    //----- end setting contact settings  --------------

    //----- start setting free blocks settings  --------------
    dataForm.free_blocks =
        data?.free_blocks?.map((ifb) => {
            ifb.style = ifb?.style ? mapImageDefault(LIST_STYLE_FREE_BLOCK).find((fbStyle) => fbStyle.id === ifb?.style) : null;
            ifb.size_title = ifb?.size_title ?? '24';
            return ifb;
        }) ?? [];
    //----- start setting free blocks settings  --------------

    //----- start setting button blocks settings  --------------
    dataForm.button_blocks =
        data?.button_blocks?.map((ibb) => {
            ibb.style = ibb?.style ? mapImageDefault(LIST_STYLE_BUTTON_BLOCK).find((fbStyle) => fbStyle.id === ibb?.style) : null;
            ibb.font_button = ibb?.font_button ? LIST_FONT_PAGE.find((fontStyle) => fontStyle.id === ibb?.font_button) : null;
            return ibb;
        }) ?? [];
    //----- start setting button blocks settings  --------------

    //----- start setting style setting settings  --------------
    dataForm.style_setting = {
        ...dataForm.style_setting,
        ...data?.style_setting,
        font: data?.style_setting?.font ? LIST_FONT_PAGE.find((fontDesign) => fontDesign.id == data.style_setting.font) : null,
        pc: {
            ...data?.style_setting?.pc,
            background_image: data?.pc_background_image ?? null,
            is_repeat: data?.style_setting?.pc?.is_repeat ? (data?.style_setting?.pc?.is_repeat === 0 ? false : true) : false
        },
        sp: {
            ...data?.style_setting?.sp,
            background_image: data?.sp_background_image ?? null,
            is_repeat: data?.style_setting?.sp?.is_repeat ? (data?.style_setting?.sp?.is_repeat === 0 ? false : true) : false
        }
    };
    //----- start setting style setting settings  --------------

    SOCIAL_MEDIA_SHARE.forEach((itemSocial) => {
        itemSocial.active = data?.block_share?.platform[itemSocial.key].active ?? false;
    });
    onHandleSetAttr(dataForm.style_setting);

    return dataForm;
}

function onHandleSetAttr(designLP) {
    let rootLP = document.documentElement;
    if (!designLP?.template_default) {
        rootLP.style.setProperty('--lp-font-family', 'Hachi Maru Pop');
        rootLP.style.setProperty('--lp-border-radius', 'none');
        rootLP.style.setProperty('--lp-background-color', '#ffffff');
        return;
    }
    for (const propertyDesgin in designLP) {
        switch (propertyDesgin) {
            case 'font':
                rootLP.style.setProperty('--lp-font-family', designLP[propertyDesgin]?.property_style?.fontFamily);
                break;
            case 'font_size':
                rootLP.style.setProperty('--lp-font-size-title-block', designLP[propertyDesgin] ? `${designLP[propertyDesgin]}px` : '24px');
                break;
            case 'border_radius_type':
                rootLP.style.setProperty('--lp-border-radius', designLP[propertyDesgin] === 2 ? '0.5rem' : 'none');
                break;
            case 'background_color':
                rootLP.style.setProperty('--lp-background-color', designLP[propertyDesgin]);
                break;
        }
    }
}

function onHandleMapBlockRes(blockO, blockRes, dataForm, data) {
    const listBlockLP = blockO.map((ob, idx) => {
        const foundBlockRes = blockRes.find((or) => or.key === ob.key);
        if (foundBlockRes) {
            return {
                block_default: foundBlockRes?.type === 'predefined',
                name: onHandleNameBlock(ob, data) ?? ob.name,
                order_index: foundBlockRes.position,
                is_visibled: blockRes[idx]?.status === 1,
                key: foundBlockRes.key ?? '',
                key_parent: ob.key_parent,
                body_html: handleMapHTML(foundBlockRes, data)
            };
        } else {
            return {
                block_default: ob.block_default,
                name: ob.name,
                order_index: idx,
                is_visibled: ob.is_visibled,
                key: ob.key,
                key_parent: ob?.key_parent,
                body_html: ''
            };
        }
    });
    return listBlockLP;
}

function onHandleNameBlock(keyO, dataApi) {
    if (!dataApi[keyO.key]) return '';
    if (['button_blocks', 'free_blocks'].includes(keyO.key)) {
        if (Array.isArray(dataApi[keyO.key])) {
            const foundTitleBlock = dataApi[keyO.key].find((sblock) => sblock.key_parent === keyO.key_parent);
            return foundTitleBlock?.title || foundTitleBlock?.title_block;
        }
    }
}

function handleResponePrize(prizeLP, prizeCP) {
    let getPizes = [];
    if (prizeLP) {
        getPizes = prizeLP.map((itemPrze) => {
            itemPrze.image = itemPrze?.image ?? {
                path: imgPrizeDefault,
                extension: 'jpg'
            };
            itemPrze.status = itemPrze.status === 0 ? false : true;
            itemPrze.detail = itemPrze.detail ?? '';
            return itemPrze;
        });
        return getPizes;
    }
    getPizes = prizeCP?.map((itemPrze, idx) => {
        return initPrizeCP(idx, itemPrze);
    });
    return getPizes;
}

function initPrizeCP(idx, itemPrze) {
    return {
        make_id: idx + 1,
        typeAction: 'Edit',
        title: itemPrze.title,
        size_prize: itemPrze.size_prize || '20',
        color_prize: itemPrze.color_prize,
        background_prize: itemPrze.background_prize,
        image: {
            path: imgPrizeDefault,
            extension: 'jpg'
        },
        detail: '',
        number_of_winner: itemPrze.number_of_win_prize,
        status: true,
        campaign_event_prize_id: itemPrze.id
    };
}

function handleMapDataFromStateLP(dataForm, allInforCampaignLP, type = null) {
    dataForm.sale_staff = allInforCampaignLP?.sale_staff ?? '';
    dataForm.person_in_charge = allInforCampaignLP?.person_in_charge ?? '';
    dataForm.zac_id = allInforCampaignLP?.zac_id;
    dataForm.sfid = allInforCampaignLP?.sfid;
    dataForm.number_cp = allInforCampaignLP?.code;

    dataForm.campaign_entity_id = allInforCampaignLP?.campaign_entity_id;
    dataForm.number_cp = allInforCampaignLP?.code;
    dataForm.campaign_start_time = formatDateCommon(allInforCampaignLP?.campaign_start_date, 'dateTime');
    dataForm.campaign_end_time = formatDateCommon(allInforCampaignLP?.campaign_end_date, 'dateTime');
    dataForm.campaign_start_date = formatDateCommon(allInforCampaignLP?.campaign_start_date, 'date');
    dataForm.campaign_end_date = formatDateCommon(allInforCampaignLP?.campaign_end_date, 'date');

    if (type === 'refreshCP') {
        dataForm.application_period = {
            ...dataForm.application_period,
            start_date: allInforCampaignLP.campaign_start_date ? moment(allInforCampaignLP.campaign_start_date).format('YYYY年MM月DD日 HH:mm') : null,
            end_date: allInforCampaignLP.campaign_end_date ? moment(allInforCampaignLP.campaign_end_date).format('YYYY年MM月DD日 HH:mm') : null
        };
        dataForm.prize_settings = {
            ...dataForm.prize_settings,
            prizes:
                dataForm.prize_settings.prizes?.length <= 0
                    ? handleResponePrize(null, allInforCampaignLP.event_prizes) ?? []
                    : handleMapPrizeRefreshCP(dataForm.prize_settings.prizes, allInforCampaignLP.event_prizes)
        };
        dataForm.block_contact = {
            ...dataForm.block_contact,
            contact_secretariat_name: allInforCampaignLP.inquiry_office ?? '',
            tel: allInforCampaignLP.master_order_scope_phone_number ?? '',
            mail: allInforCampaignLP.contact_information_email ?? ''
        };
    }
    return dataForm;
}

function handleMapPrizeRefreshCP(listPrizeBlock, prizeCP) {
    if (prizeCP?.length <= 0) return listPrizeBlock;
    prizeCP.forEach((itemB, idx) => {
        const exists = listPrizeBlock.some((itemA) => itemA.campaign_event_prize_id === itemB.id);
        if (!exists) {
            listPrizeBlock.push(initPrizeCP(idx, itemB));
        }
    });
    return listPrizeBlock;
}

function validateEndDate(startDateStr, endDateStr) {
    let check = true;
    const startDate = moment(startDateStr.valueSync, STR_DATE_TIME);
    const endDate = moment(endDateStr.valueSync, STR_DATE_TIME);
    if (!startDateStr.valueSync && !endDateStr.valueSync) return check;
    if (!endDate.isSameOrAfter(startDate)) {
        startDateStr.isShowMessCustom = false;
        endDateStr.isShowMessCustom = false;
        check = false;
        endDateStr.error = true;
        endDateStr.errorText = `${startDateStr.errorField}は${endDateStr.errorField}以下である必要があります。`;
    }
    return check;
}

function validateRangeDate(rangeStartStr, rangeEndStr, targetDateStr) {
    let check = true;
    const rangeStart = moment(rangeStartStr.valueSync, STR_DATE_TIME);
    const rangeEnd = moment(rangeEndStr.valueSync, STR_DATE_TIME);
    const targetDate = moment(targetDateStr.valueSync, STR_DATE_TIME);
    if (!rangeStartStr.valueSync && !rangeEndStr.valueSync && !targetDateStr.valueSync) return check;
    const conditionDate = rangeStart.isBefore(targetDate) && rangeEnd.isBefore(targetDate);

    if (!rangeEnd.isSameOrAfter(rangeStart)) {
        rangeStartStr.error = false;
    }

    if (!conditionDate && rangeEnd.isSameOrAfter(rangeStart)) {
        rangeStartStr.isShowMessCustom = false;
        rangeEndStr.isShowMessCustom = false;
        check = false;
        rangeStartStr.error = true;
        rangeEndStr.error = true;
        rangeStartStr.errorText = `${rangeStartStr.errorField}は${targetDateStr.errorField}以下である必要があります。`;
        rangeEndStr.errorText = `${rangeEndStr.errorField}は${targetDateStr.errorField}以下である必要があります。`;
    }
    return check;
}

function syncFormDataToConfigFormBasicLP(formData, configFormBasicLP) {
    if (!formData || !configFormBasicLP) return;

    if (configFormBasicLP.configFieldNameLandingPage && formData.name !== undefined) {
        configFormBasicLP.configFieldNameLandingPage.valueSync = formData.name ?? '';
    }
    if (configFormBasicLP.configFieldSelectCampaign && formData.campaign !== undefined) {
        configFormBasicLP.configFieldSelectCampaign.valueSync = formData.campaign ?? null;
    }
    if (configFormBasicLP.configFieldSaleStaff && formData.sale_staff !== undefined) {
        configFormBasicLP.configFieldSaleStaff.valueSync = formData.sale_staff ?? null;
    }
    if (configFormBasicLP.configFieldPICinstructions && formData.person_in_charge !== undefined) {
        configFormBasicLP.configFieldPICinstructions.valueSync = formData.person_in_charge ?? null;
    }
    if (configFormBasicLP.configFieldPublicationStartDateTime) {
        configFormBasicLP.configFieldPublicationStartDateTime.valueSync = [formData.publication_start_date, formData.publication_start_time]
            .filter(Boolean)
            .join(' ');
    }
    if (configFormBasicLP.configFieldPublicationEndDateTime) {
        configFormBasicLP.configFieldPublicationEndDateTime.valueSync = [formData.publication_end_date, formData.publication_end_time]
            .filter(Boolean)
            .join(' ');
    }
    if (configFormBasicLP.configFieldLPStartDateTime) {
        configFormBasicLP.configFieldLPStartDateTime.valueSync = [formData.lp_start_date, formData.lp_start_time].filter(Boolean).join(' ');
    }
    if (configFormBasicLP.configFieldLPEndDateTime) {
        configFormBasicLP.configFieldLPEndDateTime.valueSync = [formData.lp_end_date, formData.lp_end_time].filter(Boolean).join(' ');
    }
    if (configFormBasicLP.configFieldCampaignStartDateTime) {
        configFormBasicLP.configFieldCampaignStartDateTime.valueSync = [formData.campaign_start_date, formData.campaign_start_time]
            .filter(Boolean)
            .join(' ');
    }
    if (configFormBasicLP.configFieldCampaignEndDateTime) {
        configFormBasicLP.configFieldCampaignEndDateTime.valueSync = [formData.campaign_end_date, formData.campaign_end_time]
            .filter(Boolean)
            .join(' ');
    }
    if (configFormBasicLP.configFieldEmailLP && formData.landing_page_user) {
        configFormBasicLP.configFieldEmailLP.valueSync = formData.landing_page_user.username ?? '';
    }
    if (configFormBasicLP.configFieldPassLP && formData.landing_page_user) {
        configFormBasicLP.configFieldPassLP.valueSync = formData.landing_page_user.password ?? '';
    }
    if (configFormBasicLP.configFieldKeywordSite && formData.keywords !== undefined) {
        configFormBasicLP.configFieldKeywordSite.valueSync = formData.keywords ?? [];
    }
    if (configFormBasicLP.configFieldDescriptions && formData.description !== undefined) {
        configFormBasicLP.configFieldDescriptions.valueSync = formData.description ?? '';
    }
    if (configFormBasicLP.configFieldUrlPublic && formData.url_public !== undefined) {
        configFormBasicLP.configFieldUrlPublic.valueSync = formData.url_public ?? '';
    }
}

function handleAlertValidateTabs(conditionTab, bvToast, modelTab) {
    let check = true;
    const getArrTAB = TABS();
    const tabBasic =
        !conditionTab.checkBasicLP ||
        !conditionTab.checkStartLPWithStartCP ||
        !conditionTab.checkStartCPWithEndCP ||
        !conditionTab.checkEndLPWithEndCP ||
        !conditionTab.checkEndDatePublication ||
        !conditionTab.checkRangePublicationWidthStartLP;

    const getNameTab = getArrTAB[modelTab]?.name ?? '';
    const titleTab = {
        basic: i18n.t('landingPage.list.tabBasic'),
        time: i18n.t('landingPage.list.tabTimeApp'),
        prize: i18n.t('landingPage.list.tabPrizes'),
        target_products: i18n.t('landingPage.list.tabTargetProduct'),
        method_app: i18n.t('landingPage.list.tabMethodsApp'),
        rule_app: i18n.t('landingPage.list.tabRuleApp'),
        share: i18n.t('landingPage.list.tabShareBlock'),
        contact: i18n.t('landingPage.list.tabContact')
    };

    if (conditionTab.isUploadLP) {
        if (tabBasic) {
            if (getNameTab !== titleTab.basic) {
                showMessage(
                    8080,
                    bvToast,
                    i18n.t('validateField.tabs', {
                        field: titleTab.basic
                    })
                );
            }
            return false;
        }
        return true;
    }

    const tabTimeApplication = !conditionTab.checkTimeApplication;
    const tabPrize = !conditionTab.checkTabPrize;
    const tabTargetProduct = !conditionTab.checkTabTargetProduct;
    const tabApplicationMethods = !conditionTab.checkTabApplicationMethods;
    const tabApplicationRule = !conditionTab.checkTabApplicationRule;
    const tabShare = !conditionTab.checkTabShare;
    const tabContact = !conditionTab.checkTabContact;

    if (tabBasic && getNameTab !== titleTab.basic) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.basic
            })
        );
    }

    if (tabTimeApplication && getNameTab !== titleTab.time) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.time
            })
        );
    }

    if (tabPrize && getNameTab !== titleTab.prize) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.prize
            })
        );
    }

    if (tabTargetProduct && getNameTab !== titleTab.target_products) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.target_products
            })
        );
    }

    if (tabApplicationMethods && getNameTab !== titleTab.method_app) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.method_app
            })
        );
    }

    if (tabApplicationRule && getNameTab !== titleTab.rule_app) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.rule_app
            })
        );
    }

    if (tabShare && getNameTab !== titleTab.share) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.share
            })
        );
    }

    if (tabContact && getNameTab !== titleTab.contact) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.contact
            })
        );
    }

    if (tabBasic || tabTimeApplication || tabPrize || tabTargetProduct || tabApplicationMethods || tabApplicationRule || tabShare || tabContact) {
        check = false;
    }

    return check;
}
function handleMapHTML(paramKey, dataRes) {
    if (!dataRes[paramKey.key]) return '';
    if (Array.isArray(dataRes[paramKey.key])) {
        if (!dataRes[paramKey.key].length) return '';
        const getHtmlArr = dataRes[paramKey.key].find((gfb) => gfb?.key_parent === paramKey?.key_parent);
        return getHtmlArr?.html_content ?? '';
    } else {
        if (dataRes[paramKey.key]?.html_content) {
            return dataRes[paramKey.key]?.html_content ?? '';
        } else if (dataRes[paramKey.key]?.html_content_first_view) {
            return dataRes[paramKey.key]?.html_content_first_view ?? '';
        } else if (dataRes[paramKey.key]?.html_content_finished_view) {
            return dataRes[paramKey.key]?.html_content_finished_view ?? '';
        }
    }
}

function handleRecordLPError(router, idLP, bvToast) {
    Swal.fire({
        title: 'LPエラー',
        text: `キャンペーンが削除されたため、このLPを削除しますか。`,
        icon: 'error',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: '',
        cancelButtonColor: '#eff2f7',
        confirmButtonText: `${i18n.t('btn.ok')}`,
        cancelButtonText: `<div style="color: #212529">${i18n.t('btn.cancel')}</div>`
    }).then(async (result) => {
        if (result.value) {
            const response = await landingPageService.deleteLandingPage({ id: Number(idLP) });
            router.push({ path: '/landing-page/list' }).then(() => {
                showMessage(response.code, bvToast, 'LPが削除されました。');
            });
        } else {
            router.push({
                path: '/landing-page/list'
            });
        }
    });
}

function onHandleChangeTemp(newSetting, block, listStyle) {
    let sttF = false;
    if (!newSetting?.default_tem?.id) return sttF;
    block.style = listStyle.find((sTem) => sTem.id === newSetting?.default_tem?.id);
    if (Object.keys(block).includes('font_button')) block.font_button = newSetting?.font_family ?? null;
    sttF = true;
    return sttF;
}

function mapImageDefault(styleBlock) {
    const newStyleBlock = styleBlock.map((item) => {
        item.image_preview = LIST_TEMPLATE_DEFAULT.find((df) => df.id === item.id)?.image_preview ?? '';
        return item;
    });
    return newStyleBlock;
}

export {
    handleDataBeforeSaveLP,
    handleMapDataFromStateLP,
    validateEndDate,
    handleDataResponse,
    handleAlertValidateTabs,
    handleRecordLPError,
    handleMapHTML,
    onHandleSetAttr,
    onHandleChangeTemp,
    mapImageDefault,
    validateRangeDate,
    syncFormDataToConfigFormBasicLP
};
